<template>
    <section>

      <!-- {{localActivity}} -->
      <!-- <br> -->

      <b-field>
        <b-button class="button is-primary" @click="onNewActivity">
          NEW
        </b-button>
      </b-field>

      <div v-if="localActivity">

        <b-field>
          <h1><b>Activity Contacts / Groups</b></h1>
        </b-field>

        <b-field grouped >
        <table>
          <!-- <b-field grouped > -->
          <tr>
            <td>
              Add Groups:
            </td>
          
            <td>
              <b-field>
                <b-select placeholder="Select a group" v-model="selectedgroup"
                  icon="arrow-circle-right" icon-pack="fas">
                  <option disabled value="">--Customer Group--</option>
                  <option
                      v-for="option in segGroups"
                      :valueOLD="option"
                      :value="option.name"
                      :key="option.id">
                      {{ option.name }}
                  </option>
                  <option disabled value="">--TAGS--</option>
                  <option
                      v-for="option in getAccount.ctags"
                      :valueOLD="{id:'', name: option}"
                      :value="option"
                      :key="option">
                      {{ option}}
                  </option>
                </b-select>
              </b-field>
            </td>
            <td>
              <b-button class="button is-light" @click="onAddGroup">
                ADD
              </b-button>
            </td> 
          </tr>
        
          <tr>
            <td>
        
              Add Contacts:
            </td>
            <td>
              <b-field>
                
                <b-select placeholder="Select Contact" expanded  v-model="selectedcontact" 
                        :loading="!allContacts.length"
                        @keypress.prevent 
                        icon="arrow-circle-right" icon-pack="fas">
                  <option disabled value="">--Contacts--</option>
                  <option v-for="contact in allContacts"
                          :value="contact" :key="contact.id">
                    {{ contact.displayName }} 
                  </option>
                </b-select>
              </b-field>
            </td>
            <td>
              <b-field grouped>
                <b-button class="button is-light"  @click="onAddContact">
                  ADD
                </b-button>
              </b-field>
            </td>
          </tr>

          <tr>
        
            <td>
              Type:
            </td>
            <td>

              <b-field>
                
                <b-select placeholder="Select Tyoe" expanded  v-model="localActivity.channel" 
                      :loading="!allContacts.length"
                      @keypress.prevent 
                      icon="arrow-circle-right" icon-pack="fas">
                  <option disabled value="">--Types--</option>
                  <option v-for="item in listOfChannels"
                      :value="item.type" :key="item.id">
                    {{ item.displayName }} 
                  </option>
                </b-select>
              </b-field>
            </td>
          </tr>

        </table>
        </b-field>


        <b-field grouped>
          Groups:
          <div v-for="group in localActivity.groups" :key="group">
            <div class="tag" style=" background: green; color: white; margin-left: 0.3em;" >
            <!-- style="margin:0.2em; padding:0.2em; min-width: 3em; background: orange; color: white;" -->
              {{group}}
            </div>
          </div>
        </b-field>  
        
        <b-field grouped>  
          Contacts:
          <div v-for="item in localActivity.contacts" :key="item.id">
            <div class="tag" style=" background: orange; color: white; margin-left: 0.3em;" >
            <!-- style="margin:0.2em; padding:0.2em; min-width: 3em; background: orange; color: white;" -->
              {{item.displayName}}
            </div>
          </div>

        </b-field>


        <b-field>

          <b-field label="Header">
            <b-input maxlength="40" type="text" v-model="localActivity.header"></b-input>
          </b-field>
        </b-field>

        <b-field>

          <b-field label="Message">
            <b-input maxlength="120" type="textarea" v-model="localActivity.message"></b-input>
          </b-field>

        </b-field>





        <!-- <b-collapse class="card" aria-id="contentIdForA11y3">
            
            <b-field label="Text správy"
                :label-position="labelPosition">
                <b-input maxlength="120" type="textarea" v-model="texteditdata"></b-input>
            </b-field>

        </b-collapse> -->

        <b-field grouped style="display: block">
          <!-- <Calendar/> -->

          <!-- <h2><b>Date/Time</b></h2> -->
          <b-field grouped expanded >

              <b-field label="Date">
                <b-datepicker v-model="localActivity.due.date" >
                </b-datepicker>
              </b-field>

              <b-field label="Time">
                <b-timepicker v-model="localActivity.due.dateTime"
                    placeholder="Type or select a due time..."
                    icon="clock"
                    editable>
                </b-timepicker>
              </b-field>
          </b-field>
          <!-- Calendar -->
          <!-- <b-field>
            
          </b-field> -->

          <b-switch v-model="localActivity.done">Mark done</b-switch>

          <b-button class="button is-primary" @click="onSave">
            SAVE
          </b-button>

          <b-button class="button is-primary" @click="onDelete">
            DELETE
          </b-button>

        </b-field>

      </div>
    </section>
</template>



<script>

import { SegGroups } from "@/utils/settings"
import { ListOfChannels } from '@/utils/settings'

import { ActivityStruct } from "@/utils/structs"
// import Calendar from '@/components/main/dashboard/Calendar.vue'

import { mapGetters, mapActions } from 'vuex';

export default {

  name: 'ActivityEdit',
  components: {
    // Calendar
  },
  data() {
    return  {
      segGroups: [],
      listOfChannels: [],
      selectedgroup: null,
      selectedcontact: null,

      localActivity: null,

      // labelPosition: "0",
      texteditdata: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris."
    }
  },
  created () {
    this.segGroups = SegGroups
    this.listOfChannels = ListOfChannels

    // this.localActivity = ActivityStruct
  },
  computed: {
    ...mapGetters(['getAccount', 'allContacts','selectedActivity']), //'selectedContact'
  },
  methods: {
    ...mapActions(['putSelectedActivity', 'updateActivity', 'deleteActivity', 'addNewActivity']), //'addNewContact'
    onAddGroup () {
      if (this.selectedgroup && !this.localActivity.groups.includes(this.selectedgroup)) {
        this.localActivity.groups.push(this.selectedgroup)
      }
    },
    onAddContact () {
      if (this.selectedcontact) {
        let tmpcontact = {id: this.selectedcontact.id, displayName: this.selectedcontact.displayName}
      console.log(tmpcontact)
        if (!this.localActivity.contacts.includes(tmpcontact)) {
          this.localActivity.contacts.push(tmpcontact)
        }
      }
      
    },
    onNewActivity () {
      this.localActivity = null
      this.selectedgroup = ""
      this.selectedcontact= ""

      // this.localActivity = 
      let tmpact = JSON.parse(JSON.stringify(ActivityStruct))
      tmpact.createdate = new Date()
      tmpact.due.date = new Date()
      tmpact.due.dateTime = new Date()
      this.putSelectedActivity( tmpact )
      
    },
    onSave () {
      if (this.localActivity.id.length > 0) {
        this.updateActivity(this.localActivity)
      } else {
        this.addNewActivity(this.localActivity)
      }
      
      this.putSelectedActivity(this.localActivity)
      // 
    },
    onDelete() {
      this.deleteActivity(this.localActivity)
      this.putSelectedActivity(null)
    },
    getChannelIconClass (channeltype) {
      // TODO
    }
  },
  watch: {
    selectedActivity (newVal) {
      if (newVal) {
        // console.log(JSON.stringify(newVal))
        let tmpact = JSON.parse(JSON.stringify(newVal))
        // console.log(JSON.stringify(tmpact))
        tmpact.createdate = new Date(tmpact.createdate)
        tmpact.due.date = new Date(tmpact.due.date)
        tmpact.due.dateTime = new Date(tmpact.due.dateTime)
        
        this.localActivity = tmpact
      } else {
        this.localActivity = null
      }

      console.log("selectedActivity watch triggered @ ActivityEdit")
    }
  }
  // props: {
  //   // msg: String,
  // },
  // methods: {
  //   // clickMe () {
  //   //   window.alert(this.msg)
  //   // }
  // }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
